module.exports = __webpack_public_path__ + "static/media/Certification-amico.20da6bd3.svg";